import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

import { type TemporarySession, resetForgottenPassword } from '@asset-solutions/customer-portal/auth/data-access';
import { ColorMode } from '@asset-solutions/shared/ui';
import { Store } from '@ngrx/store';

import { NewPasswordComponent } from '../new-password/new-password.component';
import { SplashPageComponent } from '../splash-page.component';

@Component({
  selector: 'auth-reset-password',
  imports: [FormsModule, MatButton, SplashPageComponent, NewPasswordComponent],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResetPasswordComponent {
  public readonly temporarySession = input.required<TemporarySession>();
  private readonly store = inject(Store);
  protected readonly colorMode = inject(ColorMode);

  protected formData = { newPassword: '' };

  protected submitPassword(): void {
    this.store.dispatch(
      resetForgottenPassword({ password: this.formData.newPassword, sessionId: this.temporarySession().sessionId })
    );
  }
}
